<div class="row">
  <div class="col">{{ data.cartRow.productId }} - {{ data.product.name }}</div>
  <div class="col-sm-2">
    <input
      type="number"
      class="form-control"
      [step]="(!isReturnFlow) ? data.product.extra.ar?.artfsgforp || 1 : 1"
      [value]="data.cartRow.qty"
      (blur)="updateQty(data, $event.target.value)"
    />
  </div>

  <div class="col-sm-2">
    <input
      type="number"
      class="form-control"
      [value]="orEmpty(data.cartRow.extra, 'orp.vb_pris')"
      [placeholder]="data.price.customerGrossPrice.value | number: '1.0-2'"
      (blur)="updateExtraField(data, $event.target.value, 'orp.vb_pris')"
    />
  </div>
  <div class="col-sm-2">
    <input
      [disabled] =  "data.product.extra.ar?.artkundrabkod == 0 ? true : false"
      type="number"
      class="form-control"
      [value]="orEmpty(data.cartRow.extra, 'orp.kundrabatt')"
      [placeholder]="data.price.cartRowDiscountPercent"
      (blur)="updateExtraField(data, $event.target.value, 'orp.kundrabatt')"
    />
  </div>
  <div class="col">
    {{
      data.price.cartRowTotalPriceInclRowDiscount.value
        | currency: data.price.cartRowTotalPriceInclRowDiscount.currencyCode
    }}
  </div>
</div>
